/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
	ClientEntityEnumeration,
	ClientEntityResponse,
	ClientManagementConfiguration,
	ClientsForActorsResponse,
	CreateClient,
	FindClientsForActorsRequest,
	GetIsMyClientResponse,
	IncludeContactType,
	IncludeServiceContactType,
	LifeCycleStage,
	SearchClientsResponse,
	SortDirection,
	SortField,
	UpdateClient,
	UpsertClientConfigurationPayload,
} from '../models/index';
import {
	ClientEntityEnumerationFromJSON,
	ClientEntityEnumerationToJSON,
	ClientEntityResponseFromJSON,
	ClientEntityResponseToJSON,
	ClientManagementConfigurationFromJSON,
	ClientManagementConfigurationToJSON,
	ClientsForActorsResponseFromJSON,
	ClientsForActorsResponseToJSON,
	CreateClientFromJSON,
	CreateClientToJSON,
	FindClientsForActorsRequestFromJSON,
	FindClientsForActorsRequestToJSON,
	GetIsMyClientResponseFromJSON,
	GetIsMyClientResponseToJSON,
	IncludeContactTypeFromJSON,
	IncludeContactTypeToJSON,
	IncludeServiceContactTypeFromJSON,
	IncludeServiceContactTypeToJSON,
	LifeCycleStageFromJSON,
	LifeCycleStageToJSON,
	SearchClientsResponseFromJSON,
	SearchClientsResponseToJSON,
	SortDirectionFromJSON,
	SortDirectionToJSON,
	SortFieldFromJSON,
	SortFieldToJSON,
	UpdateClientFromJSON,
	UpdateClientToJSON,
	UpsertClientConfigurationPayloadFromJSON,
	UpsertClientConfigurationPayloadToJSON,
} from '../models/index';

export interface CreateClientRequest {
	xBffCsrf?: string;
	createClient?: CreateClient;
}

export interface DeleteClientRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
}

export interface DeleteConfigurationRequest {
	xBffCsrf?: string;
}

export interface FindClientsForActorsOperationRequest {
	xBffCsrf?: string;
	findClientsForActorsRequest?: FindClientsForActorsRequest;
}

export interface GetClientRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
	includeClientContactType?: IncludeContactType;
	includeServiceContactType?: IncludeServiceContactType;
}

export interface GetConfigurationRequest {
	xBffCsrf?: string;
	allowCreateConfiguration?: boolean;
}

export interface GetDeletedClientsRequest {
	xBffCsrf?: string;
	containerRID?: string;
}

export interface GetIsMyClientRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
}

export interface ListClientsRequest {
	xBffCsrf?: string;
	containerRID?: string;
	search?: string;
	lifeCycleStages?: Array<LifeCycleStage>;
	includeClientContactType?: IncludeContactType;
	includeServiceContactType?: IncludeServiceContactType;
	sortField?: SortField;
	sortDirection?: SortDirection;
	showOnlyMyClients?: boolean;
}

export interface RestoreClientRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
}

export interface SearchClientsRequest {
	xBffCsrf?: string;
	containerRID?: string;
	continuationToken?: string;
	search?: string;
	schemaName?: string;
	lifeCycleStages?: Array<LifeCycleStage>;
	serviceTeamRID?: string;
	includeClientContactType?: IncludeContactType;
	includeServiceContactType?: IncludeServiceContactType;
	sortField?: SortField;
	sortDirection?: SortDirection;
	skip?: number;
	limit?: number;
	showOnlyMyClients?: boolean;
}

export interface UpdateClientPropertiesRequest {
	encodedClientRID: string;
	xBffCsrf?: string;
	updateClient?: UpdateClient;
}

export interface UpsertConfigurationRequest {
	xBffCsrf?: string;
	upsertClientConfigurationPayload?: UpsertClientConfigurationPayload;
}

/**
 * ClientOrganizationApi - interface
 *
 * @export
 * @interface ClientOrganizationApiInterface
 */
export interface ClientOrganizationApiInterface {
	/**
	 * Endpoint create a new client organization. Also accepts a list of client contacts. If the client contact does not have actorRID then it will try to fetch the user with email, otherwise create a new user in v3. Must be a licensed user and requires client:create permission.
	 * @summary Create client
	 * @param {string} [xBffCsrf]
	 * @param {CreateClient} [createClient] Payload to create a new client organization
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	createClientRaw(
		requestParameters: CreateClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityResponse>>;

	/**
	 * Endpoint create a new client organization. Also accepts a list of client contacts. If the client contact does not have actorRID then it will try to fetch the user with email, otherwise create a new user in v3. Must be a licensed user and requires client:create permission.
	 * Create client
	 */
	createClient(
		requestParameters: CreateClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityResponse>;

	/**
	 * Endpoint deletes a client organization. Must be a licensed user and requires client:delete permission.
	 * @summary Delete client
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	deleteClientRaw(
		requestParameters: DeleteClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Endpoint deletes a client organization. Must be a licensed user and requires client:delete permission.
	 * Delete client
	 */
	deleteClient(
		requestParameters: DeleteClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Hard reset for configuration of client management. Should not generally be available to end users.
	 * @summary Delete configuration
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	deleteConfigurationRaw(
		requestParameters: DeleteConfigurationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Hard reset for configuration of client management. Should not generally be available to end users.
	 * Delete configuration
	 */
	deleteConfiguration(
		requestParameters: DeleteConfigurationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Endpoint gets clients associated with each of the provided actorRID. Requires client:read and client_clientcontact:read permission.
	 * @summary Find clients associated with each of the provided actorRID
	 * @param {string} [xBffCsrf]
	 * @param {FindClientsForActorsRequest} [findClientsForActorsRequest] Payload containing a list of ActorRIDs
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	findClientsForActorsRaw(
		requestParameters: FindClientsForActorsOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientsForActorsResponse>>;

	/**
	 * Endpoint gets clients associated with each of the provided actorRID. Requires client:read and client_clientcontact:read permission.
	 * Find clients associated with each of the provided actorRID
	 */
	findClientsForActors(
		requestParameters: FindClientsForActorsOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientsForActorsResponse>;

	/**
	 * Endpoint gets a client organization by its RID. Requires client:read permission.
	 * @summary Get a client
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {IncludeContactType} [includeClientContactType]
	 * @param {IncludeServiceContactType} [includeServiceContactType]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	getClientRaw(
		requestParameters: GetClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityResponse>>;

	/**
	 * Endpoint gets a client organization by its RID. Requires client:read permission.
	 * Get a client
	 */
	getClient(
		requestParameters: GetClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityResponse>;

	/**
	 * Get configuration for client management. Provides admin control and arrangement guarantees.
	 * @summary Get configuration
	 * @param {string} [xBffCsrf]
	 * @param {boolean} [allowCreateConfiguration] Specifies whether to allow creating a new configuration if none exists based on user role.
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	getConfigurationRaw(
		requestParameters: GetConfigurationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientManagementConfiguration>>;

	/**
	 * Get configuration for client management. Provides admin control and arrangement guarantees.
	 * Get configuration
	 */
	getConfiguration(
		requestParameters: GetConfigurationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientManagementConfiguration>;

	/**
	 * Endpoint gets a list of deleted clients. Requires client:read permission for each item of the list.
	 * @summary Get deleted clients
	 * @param {string} [xBffCsrf]
	 * @param {string} [containerRID]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	getDeletedClientsRaw(
		requestParameters: GetDeletedClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityEnumeration>>;

	/**
	 * Endpoint gets a list of deleted clients. Requires client:read permission for each item of the list.
	 * Get deleted clients
	 */
	getDeletedClients(
		requestParameters: GetDeletedClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityEnumeration>;

	/**
	 * Check if the current user is a member of the client either directly as a service contact or as assigned team members of a service team assigned to the client. Requires client:read permission.
	 * @summary Check if client is my client
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	getIsMyClientRaw(
		requestParameters: GetIsMyClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<GetIsMyClientResponse>>;

	/**
	 * Check if the current user is a member of the client either directly as a service contact or as assigned team members of a service team assigned to the client. Requires client:read permission.
	 * Check if client is my client
	 */
	getIsMyClient(
		requestParameters: GetIsMyClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<GetIsMyClientResponse>;

	/**
	 * Endpoint gets a list of client organizations that may be addressed in the system. This endpoint will only include client contacts or service contacts if query params are passed with includeContactType, this requires client_clientcontact:read, client_servicecontact:read to read the contacts. Requires client:read permission for each item of the list.
	 * @summary List clients
	 * @param {string} [xBffCsrf]
	 * @param {string} [containerRID]
	 * @param {string} [search] Search term that will be matched against multiple fields. Search performs: 1) Partial word matches or fuzzy matches (first two chars match, single character difference) in the InternalName field, 2) Fuzzy matches (first two chars match, single character difference) in custom metadata fields, 3) Exact matches in the ExternalIdentifier field. A client is returned if a match is found in any of these cases.
	 * @param {Array<LifeCycleStage>} [lifeCycleStages]
	 * @param {IncludeContactType} [includeClientContactType]
	 * @param {IncludeServiceContactType} [includeServiceContactType]
	 * @param {SortField} [sortField]
	 * @param {SortDirection} [sortDirection]
	 * @param {boolean} [showOnlyMyClients]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	listClientsRaw(
		requestParameters: ListClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityEnumeration>>;

	/**
	 * Endpoint gets a list of client organizations that may be addressed in the system. This endpoint will only include client contacts or service contacts if query params are passed with includeContactType, this requires client_clientcontact:read, client_servicecontact:read to read the contacts. Requires client:read permission for each item of the list.
	 * List clients
	 */
	listClients(
		requestParameters: ListClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityEnumeration>;

	/**
	 * Endpoint restores a client organization. Must be a licensed user and requires client:delete permission.
	 * @summary Restore client
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	restoreClientRaw(
		requestParameters: RestoreClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>>;

	/**
	 * Endpoint restores a client organization. Must be a licensed user and requires client:delete permission.
	 * Restore client
	 */
	restoreClient(
		requestParameters: RestoreClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void>;

	/**
	 * Endpoint searches client entities and returns a paged list of client results.  Search will look for matching text within: - **InternalName field** - **Custom metadata fields** - **uniqueIdentifier field**  This endpoint will only include client contacts or service contacts if query params are passed with includeContactType, this requires client_clientcontact:read, client_servicecontact:read to read the contacts. Requires client:read permission for each item of the list.
	 * @summary Search clients
	 * @param {string} [xBffCsrf]
	 * @param {string} [containerRID]
	 * @param {string} [continuationToken] Continuation token for pagination returned from previous search
	 * @param {string} [search] Search term. 1) **InternalName field**: Partial word matches (autocomplete up to 7 chars) or fuzzy matches (first two chars match, single character difference) 2) **Custom metadata fields**: Fuzzy matches (first two chars match, single character difference) 3) **uniqueIdentifier field**: Exact match.
	 * @param {string} [schemaName] Filter by metadata schema name
	 * @param {Array<LifeCycleStage>} [lifeCycleStages]
	 * @param {string} [serviceTeamRID] Filter by service team RID that is assigned to the client.
	 * @param {IncludeContactType} [includeClientContactType]
	 * @param {IncludeServiceContactType} [includeServiceContactType]
	 * @param {SortField} [sortField]
	 * @param {SortDirection} [sortDirection]
	 * @param {number} [skip]
	 * @param {number} [limit]
	 * @param {boolean} [showOnlyMyClients]
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	searchClientsRaw(
		requestParameters: SearchClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<SearchClientsResponse>>;

	/**
	 * Endpoint searches client entities and returns a paged list of client results.  Search will look for matching text within: - **InternalName field** - **Custom metadata fields** - **uniqueIdentifier field**  This endpoint will only include client contacts or service contacts if query params are passed with includeContactType, this requires client_clientcontact:read, client_servicecontact:read to read the contacts. Requires client:read permission for each item of the list.
	 * Search clients
	 */
	searchClients(
		requestParameters: SearchClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<SearchClientsResponse>;

	/**
	 * Endpoint updates the mutable properties of a client organization. Requires a licensed user and client:modify permission.
	 * @summary Update client
	 * @param {string} encodedClientRID
	 * @param {string} [xBffCsrf]
	 * @param {UpdateClient} [updateClient] A payload for updating a client
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	updateClientPropertiesRaw(
		requestParameters: UpdateClientPropertiesRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityResponse>>;

	/**
	 * Endpoint updates the mutable properties of a client organization. Requires a licensed user and client:modify permission.
	 * Update client
	 */
	updateClientProperties(
		requestParameters: UpdateClientPropertiesRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityResponse>;

	/**
	 * Create or update configuration for client management.
	 * @summary Create or update configuration
	 * @param {string} [xBffCsrf]
	 * @param {UpsertClientConfigurationPayload} [upsertClientConfigurationPayload] Payload to create a new client management settings configuration document
	 * @param {*} [options] Override http request option.
	 * @throws {RequiredError}
	 * @memberof ClientOrganizationApiInterface
	 */
	upsertConfigurationRaw(
		requestParameters: UpsertConfigurationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientManagementConfiguration>>;

	/**
	 * Create or update configuration for client management.
	 * Create or update configuration
	 */
	upsertConfiguration(
		requestParameters: UpsertConfigurationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientManagementConfiguration>;
}

/**
 *
 */
export class ClientOrganizationApi
	extends runtime.BaseAPI
	implements ClientOrganizationApiInterface
{
	/**
	 * Endpoint create a new client organization. Also accepts a list of client contacts. If the client contact does not have actorRID then it will try to fetch the user with email, otherwise create a new user in v3. Must be a licensed user and requires client:create permission.
	 * Create client
	 */
	async createClientRaw(
		requestParameters: CreateClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityResponse>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: CreateClientToJSON(requestParameters.createClient),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientEntityResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint create a new client organization. Also accepts a list of client contacts. If the client contact does not have actorRID then it will try to fetch the user with email, otherwise create a new user in v3. Must be a licensed user and requires client:create permission.
	 * Create client
	 */
	async createClient(
		requestParameters: CreateClientRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityResponse> {
		const response = await this.createClientRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint deletes a client organization. Must be a licensed user and requires client:delete permission.
	 * Delete client
	 */
	async deleteClientRaw(
		requestParameters: DeleteClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling deleteClient.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'DELETE',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Endpoint deletes a client organization. Must be a licensed user and requires client:delete permission.
	 * Delete client
	 */
	async deleteClient(
		requestParameters: DeleteClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.deleteClientRaw(requestParameters, initOverrides);
	}

	/**
	 * Hard reset for configuration of client management. Should not generally be available to end users.
	 * Delete configuration
	 */
	async deleteConfigurationRaw(
		requestParameters: DeleteConfigurationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/configuration`,
				method: 'DELETE',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Hard reset for configuration of client management. Should not generally be available to end users.
	 * Delete configuration
	 */
	async deleteConfiguration(
		requestParameters: DeleteConfigurationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.deleteConfigurationRaw(requestParameters, initOverrides);
	}

	/**
	 * Endpoint gets clients associated with each of the provided actorRID. Requires client:read and client_clientcontact:read permission.
	 * Find clients associated with each of the provided actorRID
	 */
	async findClientsForActorsRaw(
		requestParameters: FindClientsForActorsOperationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientsForActorsResponse>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/findClientsForActors`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: FindClientsForActorsRequestToJSON(
					requestParameters.findClientsForActorsRequest
				),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientsForActorsResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint gets clients associated with each of the provided actorRID. Requires client:read and client_clientcontact:read permission.
	 * Find clients associated with each of the provided actorRID
	 */
	async findClientsForActors(
		requestParameters: FindClientsForActorsOperationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientsForActorsResponse> {
		const response = await this.findClientsForActorsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint gets a client organization by its RID. Requires client:read permission.
	 * Get a client
	 */
	async getClientRaw(
		requestParameters: GetClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityResponse>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling getClient.'
			);
		}

		const queryParameters: any = {};

		if (requestParameters.includeClientContactType !== undefined) {
			queryParameters['includeClientContactType'] =
				requestParameters.includeClientContactType;
		}

		if (requestParameters.includeServiceContactType !== undefined) {
			queryParameters['includeServiceContactType'] =
				requestParameters.includeServiceContactType;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientEntityResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint gets a client organization by its RID. Requires client:read permission.
	 * Get a client
	 */
	async getClient(
		requestParameters: GetClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityResponse> {
		const response = await this.getClientRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Get configuration for client management. Provides admin control and arrangement guarantees.
	 * Get configuration
	 */
	async getConfigurationRaw(
		requestParameters: GetConfigurationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientManagementConfiguration>> {
		const queryParameters: any = {};

		if (requestParameters.allowCreateConfiguration !== undefined) {
			queryParameters['allowCreateConfiguration'] =
				requestParameters.allowCreateConfiguration;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/configuration`,
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientManagementConfigurationFromJSON(jsonValue)
		);
	}

	/**
	 * Get configuration for client management. Provides admin control and arrangement guarantees.
	 * Get configuration
	 */
	async getConfiguration(
		requestParameters: GetConfigurationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientManagementConfiguration> {
		const response = await this.getConfigurationRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint gets a list of deleted clients. Requires client:read permission for each item of the list.
	 * Get deleted clients
	 */
	async getDeletedClientsRaw(
		requestParameters: GetDeletedClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityEnumeration>> {
		const queryParameters: any = {};

		if (requestParameters.containerRID !== undefined) {
			queryParameters['containerRID'] = requestParameters.containerRID;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/deletedclients`,
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientEntityEnumerationFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint gets a list of deleted clients. Requires client:read permission for each item of the list.
	 * Get deleted clients
	 */
	async getDeletedClients(
		requestParameters: GetDeletedClientsRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityEnumeration> {
		const response = await this.getDeletedClientsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Check if the current user is a member of the client either directly as a service contact or as assigned team members of a service team assigned to the client. Requires client:read permission.
	 * Check if client is my client
	 */
	async getIsMyClientRaw(
		requestParameters: GetIsMyClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<GetIsMyClientResponse>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling getIsMyClient.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/isMyClient`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			GetIsMyClientResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Check if the current user is a member of the client either directly as a service contact or as assigned team members of a service team assigned to the client. Requires client:read permission.
	 * Check if client is my client
	 */
	async getIsMyClient(
		requestParameters: GetIsMyClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<GetIsMyClientResponse> {
		const response = await this.getIsMyClientRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint gets a list of client organizations that may be addressed in the system. This endpoint will only include client contacts or service contacts if query params are passed with includeContactType, this requires client_clientcontact:read, client_servicecontact:read to read the contacts. Requires client:read permission for each item of the list.
	 * List clients
	 */
	async listClientsRaw(
		requestParameters: ListClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityEnumeration>> {
		const queryParameters: any = {};

		if (requestParameters.containerRID !== undefined) {
			queryParameters['containerRID'] = requestParameters.containerRID;
		}

		if (requestParameters.search !== undefined) {
			queryParameters['search'] = requestParameters.search;
		}

		if (requestParameters.lifeCycleStages) {
			queryParameters['lifeCycleStages'] = requestParameters.lifeCycleStages;
		}

		if (requestParameters.includeClientContactType !== undefined) {
			queryParameters['includeClientContactType'] =
				requestParameters.includeClientContactType;
		}

		if (requestParameters.includeServiceContactType !== undefined) {
			queryParameters['includeServiceContactType'] =
				requestParameters.includeServiceContactType;
		}

		if (requestParameters.sortField !== undefined) {
			queryParameters['sortField'] = requestParameters.sortField;
		}

		if (requestParameters.sortDirection !== undefined) {
			queryParameters['sortDirection'] = requestParameters.sortDirection;
		}

		if (requestParameters.showOnlyMyClients !== undefined) {
			queryParameters['showOnlyMyClients'] = requestParameters.showOnlyMyClients;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/list`,
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientEntityEnumerationFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint gets a list of client organizations that may be addressed in the system. This endpoint will only include client contacts or service contacts if query params are passed with includeContactType, this requires client_clientcontact:read, client_servicecontact:read to read the contacts. Requires client:read permission for each item of the list.
	 * List clients
	 */
	async listClients(
		requestParameters: ListClientsRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityEnumeration> {
		const response = await this.listClientsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint restores a client organization. Must be a licensed user and requires client:delete permission.
	 * Restore client
	 */
	async restoreClientRaw(
		requestParameters: RestoreClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling restoreClient.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}/restore`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 * Endpoint restores a client organization. Must be a licensed user and requires client:delete permission.
	 * Restore client
	 */
	async restoreClient(
		requestParameters: RestoreClientRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.restoreClientRaw(requestParameters, initOverrides);
	}

	/**
	 * Endpoint searches client entities and returns a paged list of client results.  Search will look for matching text within: - **InternalName field** - **Custom metadata fields** - **uniqueIdentifier field**  This endpoint will only include client contacts or service contacts if query params are passed with includeContactType, this requires client_clientcontact:read, client_servicecontact:read to read the contacts. Requires client:read permission for each item of the list.
	 * Search clients
	 */
	async searchClientsRaw(
		requestParameters: SearchClientsRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<SearchClientsResponse>> {
		const queryParameters: any = {};

		if (requestParameters.containerRID !== undefined) {
			queryParameters['containerRID'] = requestParameters.containerRID;
		}

		if (requestParameters.continuationToken !== undefined) {
			queryParameters['continuationToken'] = requestParameters.continuationToken;
		}

		if (requestParameters.search !== undefined) {
			queryParameters['search'] = requestParameters.search;
		}

		if (requestParameters.schemaName !== undefined) {
			queryParameters['schemaName'] = requestParameters.schemaName;
		}

		if (requestParameters.lifeCycleStages) {
			queryParameters['lifeCycleStages'] = requestParameters.lifeCycleStages;
		}

		if (requestParameters.serviceTeamRID !== undefined) {
			queryParameters['serviceTeamRID'] = requestParameters.serviceTeamRID;
		}

		if (requestParameters.includeClientContactType !== undefined) {
			queryParameters['includeClientContactType'] =
				requestParameters.includeClientContactType;
		}

		if (requestParameters.includeServiceContactType !== undefined) {
			queryParameters['includeServiceContactType'] =
				requestParameters.includeServiceContactType;
		}

		if (requestParameters.sortField !== undefined) {
			queryParameters['sortField'] = requestParameters.sortField;
		}

		if (requestParameters.sortDirection !== undefined) {
			queryParameters['sortDirection'] = requestParameters.sortDirection;
		}

		if (requestParameters.skip !== undefined) {
			queryParameters['skip'] = requestParameters.skip;
		}

		if (requestParameters.limit !== undefined) {
			queryParameters['limit'] = requestParameters.limit;
		}

		if (requestParameters.showOnlyMyClients !== undefined) {
			queryParameters['showOnlyMyClients'] = requestParameters.showOnlyMyClients;
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/search`,
				method: 'GET',
				headers: headerParameters,
				query: queryParameters,
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			SearchClientsResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint searches client entities and returns a paged list of client results.  Search will look for matching text within: - **InternalName field** - **Custom metadata fields** - **uniqueIdentifier field**  This endpoint will only include client contacts or service contacts if query params are passed with includeContactType, this requires client_clientcontact:read, client_servicecontact:read to read the contacts. Requires client:read permission for each item of the list.
	 * Search clients
	 */
	async searchClients(
		requestParameters: SearchClientsRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<SearchClientsResponse> {
		const response = await this.searchClientsRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Endpoint updates the mutable properties of a client organization. Requires a licensed user and client:modify permission.
	 * Update client
	 */
	async updateClientPropertiesRaw(
		requestParameters: UpdateClientPropertiesRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientEntityResponse>> {
		if (
			requestParameters.encodedClientRID === null ||
			requestParameters.encodedClientRID === undefined
		) {
			throw new runtime.RequiredError(
				'encodedClientRID',
				'Required parameter requestParameters.encodedClientRID was null or undefined when calling updateClientProperties.'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/clients/{encodedClientRID}`.replace(
					`{${'encodedClientRID'}}`,
					encodeURIComponent(String(requestParameters.encodedClientRID))
				),
				method: 'PUT',
				headers: headerParameters,
				query: queryParameters,
				body: UpdateClientToJSON(requestParameters.updateClient),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientEntityResponseFromJSON(jsonValue)
		);
	}

	/**
	 * Endpoint updates the mutable properties of a client organization. Requires a licensed user and client:modify permission.
	 * Update client
	 */
	async updateClientProperties(
		requestParameters: UpdateClientPropertiesRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientEntityResponse> {
		const response = await this.updateClientPropertiesRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}

	/**
	 * Create or update configuration for client management.
	 * Create or update configuration
	 */
	async upsertConfigurationRaw(
		requestParameters: UpsertConfigurationRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ClientManagementConfiguration>> {
		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (requestParameters.xBffCsrf !== undefined && requestParameters.xBffCsrf !== null) {
			headerParameters['x-bff-csrf'] = String(requestParameters.xBffCsrf);
		}

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken(
				'OAuth2-Test',
				[
					'clientmanagement:client.read',
					'clientmanagement:client.write',
					'clientmanagement:client.delete',
					'clientmanagement:metadataschema.read',
					'clientmanagement:metadataschema.write',
					'clientmanagement:metadataschema.delete',
					'clientmanagement:configuration.write',
					'clientmanagement:client.packaging',
					'clientmanagement:activity.write',
					'clientmanagement:serviceteam.read',
					'clientmanagement:serviceteam.write',
					'clientmanagement:serviceteam.delete',
				]
			);
		}

		const response = await this.request(
			{
				path: `/configuration`,
				method: 'POST',
				headers: headerParameters,
				query: queryParameters,
				body: UpsertClientConfigurationPayloadToJSON(
					requestParameters.upsertClientConfigurationPayload
				),
			},
			initOverrides
		);

		return new runtime.JSONApiResponse(response, jsonValue =>
			ClientManagementConfigurationFromJSON(jsonValue)
		);
	}

	/**
	 * Create or update configuration for client management.
	 * Create or update configuration
	 */
	async upsertConfiguration(
		requestParameters: UpsertConfigurationRequest = {},
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ClientManagementConfiguration> {
		const response = await this.upsertConfigurationRaw(requestParameters, initOverrides);
		return await response.value();
	}
}
